import { eveningHot } from "@/mocks/site";

interface HotListCardProps {
  limit?: number;
  title?: string;
}

const rankTone = (rank: number) => {
  if (rank === 1) return "bg-primary-500 text-background-50";
  if (rank === 2) return "bg-primary-400 text-background-50";
  if (rank === 3) return "bg-accent-500 text-foreground-950";
  return "bg-background-300 text-foreground-700";
};

const tagTone = (tag: string) => {
  if (tag === "沸") return "bg-primary-500 text-background-50";
  if (tag === "热") return "bg-accent-500 text-foreground-950";
  return "bg-secondary-500 text-background-50";
};

export default function HotListCard({ limit = 8, title = "今晚热搜榜" }: HotListCardProps) {
  const list = eveningHot.slice(0, limit);

  return (
    <div className="rounded-lg border border-background-300/60 bg-background-100 p-5">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <span className="w-5 h-5 flex items-center justify-center text-primary-500">
            <i className="ri-fire-fill" aria-hidden="true"></i>
          </span>
          {title}
        </h3>
        <span className="inline-flex items-center gap-1.5 text-[11px] text-primary-600">
          <span className="relative w-1.5 h-1.5 rounded-full bg-primary-500 live-dot" />
          实时更新
        </span>
      </div>

      <ol className="mt-4 space-y-1">
        {list.map((item) => (
          <li key={item.rank}>
            <div className="flex items-start gap-3 rounded-md px-2 py-2.5 hover:bg-primary-50/70 transition-colors">
              <span
                className={`mt-0.5 w-5 h-5 shrink-0 flex items-center justify-center rounded text-[11px] font-bold ${rankTone(
                  item.rank,
                )}`}
              >
                {item.rank}
              </span>
              <div className="min-w-0">
                <p className="text-sm leading-6 text-foreground-900 line-clamp-2">{item.title}</p>
                <div className="mt-1 flex items-center gap-2">
                  <span className="text-[11px] text-foreground-500">热度 {item.heat}</span>
                  {item.tag && (
                    <span className={`rounded px-1.5 py-0.5 text-[10px] font-medium ${tagTone(item.tag)}`}>
                      {item.tag}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}